import React, {useEffect, useState, useContext} from 'react';
import './header.css'
import Logo from '../../assets/logo.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { ShareContext } from '../../context/ShareContext';
import * as Constants from '../../constants';

function Header() {

  const path = useLocation();
  const navigate = useNavigate();
  const login = path.pathname.includes('login') || path.pathname.includes('signup') || path.pathname.includes('search') 
  const { profile,token } = useContext(ShareContext)
const onLogout =()=>{
 if(token==null){
  window.location.replace(`${Constants.primarySite}/index.html`)
 }else{
  localStorage.removeItem('token');
  localStorage.removeItem('profile');
  navigate("/login")
 }
}
  return login ? null : (
    <header className='no-print'>
        <div className="top">
            <div className="title">
              <img src={Logo}  alt='JIS Logo' />
              <div className="title-text">
                <h2>LAGOS STATE <br /> JUDICIARY</h2>
                <h4>JUDICIARY INFORMATION SYSTEM(JIS)</h4>
              </div>
            </div>
          {profile.username!=null && <div className="profile-bar">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 346 67" fill="none">
                <path d="M0 0H346V67H35.038L0 0Z" fill="#333333"/>
              </svg>
              <div className="name-log">
              <div className="name">
                <FontAwesomeIcon icon={faUser} />
                <p>{profile.username}</p>
              </div>
              <button className="red" onClick={onLogout}>Log Out</button>
              </div>
            </div>}  
        </div>
    </header>
  )
}

export default Header